export default __webpack_public_path__ + "media/images/svg/full_logo-a89de4aa33bcccb90960bf62599c5ee5.svg";